import { Component, OnInit, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SupabaseService } from './core/services/supabase.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App implements OnInit {
  protected readonly title = signal('booking-system');
  private supabase = inject(SupabaseService);

  ngOnInit() {
    console.log('Supabase Client Initialized:', this.supabase.client);
  }
}
